import type { TextAreaProps } from "antd/es/input"

// UI/UX guidelines §5.6. The counter is noise on a one-line description, so it
// appears only once the text is long enough for the writer to lose track of it.
const DESCRIPTION_COUNT_FROM = 200

/** Shared so the create wizard and the settings modal present the same field. */
export const descriptionTextAreaProps: Pick<
  TextAreaProps,
  "autoSize" | "showCount"
> = {
  autoSize: { minRows: 4, maxRows: 8 },
  showCount: {
    formatter: ({ count }) =>
      count >= DESCRIPTION_COUNT_FROM ? String(count) : ""
  }
}
